import {
  BulkDiscountClient,
  CouponClient,
  RedeemProductClient,
  DSODiscountClient,
} from 'types';
import getConfig from 'next/config';
import { PromotionListClient } from 'types';
import { ClientSubscriptionProduct } from 'types/Subscription.types';

export const filterCouponsBySku = (
  sku: string,
  promotionList?: PromotionListClient
): CouponClient | undefined => {
  const skuMatch = promotionList?.productsList
    .find(p => p.sku === sku)
    ?.discounts.find((d): d is CouponClient => d.discountType === 'coupon');

  if (skuMatch) return skuMatch;
};

export const hasDiscountBySku = (
  sku: string,
  promotionList?: PromotionListClient
): boolean => {
  const hasSkuDiscount = Boolean(
    promotionList?.productsList.find(p => p.sku === sku)?.discounts.length
  );
  if (hasSkuDiscount) return true;
  return false;
};

export const filterBulkDiscountBySku = (
  sku: string,
  promotionList?: PromotionListClient
): BulkDiscountClient | undefined => {
  if (!promotionList) {
    return undefined;
  }

  const skuMatch = promotionList.productsList
    .find(product => product.sku === sku)
    ?.discounts.find(
      (d): d is BulkDiscountClient => d.discountType === 'bulk_discount'
    );

  if (skuMatch) return skuMatch;
};

export const filterDSODiscountBySku = (
  sku: string,
  promotionList?: PromotionListClient
): DSODiscountClient | undefined => {
  if (!promotionList) {
    return undefined;
  }

  const skuMatch = promotionList.productsList
    .find(product => product.sku === sku)
    ?.discounts.find(
      (d): d is DSODiscountClient => d.discountType === 'dso_discount'
    );

  if (skuMatch) return skuMatch;
};

export const filterRedeemProductBySku = (
  productSku: string,
  redeemList?: RedeemProductClient[]
) => {
  if (!redeemList) {
    return;
  }
  const redeemProduct = redeemList.find(redeem => redeem.sku === productSku);

  return redeemProduct;
};

export const isRedeemRegion = (userRegion = '') => {
  const availableRegions = ['APAC'];
  return availableRegions.includes(userRegion);
};
export const isRedeemAvailable = (
  productSku: string,
  redeemProductList?: RedeemProductClient[]
) => {
  const { publicRuntimeConfig } = getConfig();
  const userRegion = publicRuntimeConfig.STORE_REGION.toUpperCase();

  const redeemProduct = filterRedeemProductBySku(productSku, redeemProductList);

  return isRedeemRegion(userRegion) && Boolean(redeemProduct);
};

export const filterSubscriptionsBySku = (
  sku: string,
  subscriptions?: ClientSubscriptionProduct[]
) => {
  if (!subscriptions) {
    return;
  }

  return subscriptions.find(subscription => subscription.sku === sku);
};

export const isSubscriableProduct = (
  subscribableProductList: ClientSubscriptionProduct[] | undefined,
  productSku: string
) => {
  return (
    subscribableProductList?.find(
      subscriptionProduct => subscriptionProduct.sku === productSku
    ) !== undefined
  );
};

export const maxDiscount = (product: ClientSubscriptionProduct | null) => {
  if (!product || !product.options) return null;

  let maxDiscount = 0;

  product.options.forEach(option => {
    option.frequencies.forEach(freq => {
      const discountValue = parseFloat(freq.discount.replace('%', ''));

      if (discountValue > maxDiscount) {
        maxDiscount = discountValue;
      }
    });
  });

  return maxDiscount;
};

export const getSubscriptionProduct = (
  subscriptionProductList: ClientSubscriptionProduct[] | undefined,
  productSku: string
) => {
  return (
    subscriptionProductList?.find(
      subscriptionProduct => subscriptionProduct.sku === productSku
    ) || null
  );
};
